<template>
  <v-container v-if="loading">
    <div class="text-xs-center">
      <v-progress-circular
        indeterminate
        :size="150"
        :width="8">
      </v-progress-circular>
    </div>
  </v-container>

  <v-container v-else fluid grid-list-md>
    <v-layout column>
      <v-flex xs12 sm6>
        <v-card>
          <div class="flex xs12 page-header">{{ this.newsSource }}</div>
          <news-cards v-bind:articles="articles" v-bind:noData="noData"></news-cards>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>

import newsApi from '@/services/NewsApi'

export default {
  name: 'RecallNews',
  props: {
    name: String
  },
  data () {
    return {
      articles: [],
      newsSource: '',
      newsFeed: '',
      show: false,
      isList: false,
      loading: true,
      noData: false
    }
  },
  methods: {
    fetchNewsData () {
      switch (this.name) {
        case 'FDARecalls':
          this.newsSource = 'FDA Recalls'
          this.newsFeed = 'https://www.fda.gov/AboutFDA/ContactFDA/StayInformed/RSSFeeds/Recalls/rss.xml'
          break
        case 'FoodSafety':
          this.newsSource = 'Food Safety'
          this.newsFeed = 'https://www.fda.gov/AboutFDA/ContactFDA/StayInformed/RSSFeeds/FoodSafety/rss.xml'
          break
        case 'FoodAllergy':
          this.newsSource = 'Food Allergy'
          this.newsFeed = 'https://www.fda.gov/AboutFDA/ContactFDA/StayInformed/RSSFeeds/FoodAllergies/rss.xml'
          break
        case 'DrugRecalls':
          this.newsSource = 'Drug Recalls'
          this.newsFeed = 'https://www.fda.gov/AboutFDA/ContactFDA/StayInformed/RSSFeeds/DrugRecalls/rss.xml'
          break
        case 'MedWatch':
          this.newsSource = 'Med Watch'
          this.newsFeed = 'https://www.fda.gov/AboutFDA/ContactFDA/StayInformed/RSSFeeds/MedWatch/rss.xml'
          break
        case 'PetHealth':
          this.newsSource = 'Pet Health'
          this.newsFeed = 'https://www.fda.gov/AboutFDA/ContactFDA/StayInformed/RSSFeeds/PetHealth/rss.xml'
          break
        case 'VehicleRecalls':
          this.newsSource = 'Vehicle Recalls'
          this.newsFeed = 'https://www-odi.nhtsa.dot.gov/rss/feeds/rss_recalls_V.xml'
          break
        case 'TireRecalls':
          this.newsSource = 'Tire Recalls'
          this.newsFeed = 'https://www-odi.nhtsa.dot.gov/rss/feeds/rss_recalls_T.xml'
          break
        case 'ChildRestraintRecalls':
          this.newsSource = 'Child Retraint Recalls'
          this.newsFeed = 'https://www-odi.nhtsa.dot.gov/rss/feeds/rss_recalls_C.xml'
          break
      }

      newsApi.fetchNewsCollection(this.newsFeed)
        .then(response => {
          // console.log(response)
          if (Object.keys(response).length) {
            // this.recalls = response
            this.articles = this.articles.concat(response)
            this.loading = false
            this.noData = false
          } else {
            this.noData = true
            this.loading = false
          }
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log(error)
        })
    }
  },
  mounted () {
    this.fetchNewsData()
  }
}
</script>
